export const ScoreType = {
  boolean: 0,
  reps: 1,
  roundreps: 2,
  time: 3,
  weight: 4,
  deadlift: 5,
  text: 6,
  calories: 7,
  meters: 8,
};

export const ScoreTypeLabel = {
  ForComletion: "For Completion",
  Reps: "Reps",
  RoundReps: "Round Reps",
  Time: "Time",
  Weight: "Weight",
  Deadlift: "Deadlift",
};
